import { Box } from '@bechtel/gds';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const LogoSectionStyled = styled(Box).attrs({ p: { sm: '400' }, mb: { sm: '400' } })`
  ${({ theme }) => css`
    background-image: linear-gradient(238deg, ${theme.colors.primary[700]}, ${theme.colors.bechtel.blue[1000]});
    justify-content: center;
  `};
`;

export const NavigationContentStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-image: linear-gradient(184deg, ${theme.colors.grey[100]}, ${theme.colors.grey[200]});
    color: ${theme.colors.grey[200]};
    width: ${theme.componentStyles.navBarWidth};
    transition: width 40ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  `};
`;

export const NavigationStyled = styled.div`
  height: 100%;
`;

interface NavigationLinkProps {
  isActive?: boolean;
  isNav?:boolean;
}

export const LinkStyled = styled(NavLink)<NavigationLinkProps>`
  align-items: center;
  justify-content: center;
  border-left: 4px solid transparent;
  display: flex;
  text-decoration: none;
  transition-duration: 240ms;
  transition-property: background-color, border-color, color;
  transition-timing-function: ease-in-out;
  user-select: none;
  white-space: nowrap;

  ${({ theme }) => css`
    color: ${theme.colors.grey[900]};
    font-size: ${theme.fontSizes[400]};
    line-height: ${theme.fontSizes[700]}; /* higher explicit line-height required for variable icon heights */
    padding-top: ${theme.spacings[300]};
    padding-bottom: ${theme.spacings[300]};
    padding-left: ${theme.spacings[300]};
  `};

  & > * {
    margin-right: ${({ theme }) => theme.spacings[500]};
  }

  &:active,
  &.active {
    background-color:${({isNav})=> isNav?'transparent' :'white'};
    border-color: ${({ theme,isNav }) => isNav?'transparent': theme.colors.blue[600]};
    font-weight: ${({ theme }) => theme.fontWeights[600]};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.bechtel.red[700]};
    transition-duration: 80ms;
  }
`;

export const UserAdminLinkStyled = styled(LinkStyled)<NavigationLinkProps>`
  min-height: 52px;
  & > * {
    margin-right: ${({ theme }) => theme.spacings[450]};
  }
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacings[300]};
`;
export const LogoAreaStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  mt: { sm: '200' },
})``;

export const UserSettingSectionStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  py: { sm: '400' },
})`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.grey[300]};
  `};
`;
export const UserEmulateStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'center' },
  mt: { sm: '400' },
})``;

export const EmulateItemStyled = styled(Box)`
  ${({ theme }) => css`
    color: ${theme.colors.red[900]};
    font-size: ${theme.fontSizes[400]};
    line-height: ${theme.fontSizes[700]}; /* higher explicit line-height required for variable icon heights */
  `};
`;
